import { BaseModel } from './base.model'
import { HubCourseTimetable } from './hub-course-timetable.model'
import { CenterProgram } from './center-program.model'
import { BriefingAuditor } from './biefing-auditor.model'

export class Briefing extends BaseModel<Briefing> {
  name: string
  cityId: number
  cityName: string
  comment: string
  address: string
  remindInMinutes: number
  cityUtcOffset: number
  mkkInspectionMode: string
  mkkRegion: number
  
  registrationCreatedSmsId: number
  registrationCanceledSmsId: number
  registrationReminderSmsId: number

  centerPrograms: CenterProgram[]
  timetable: HubCourseTimetable
  photos: { url: string, title: string }[]
  auditor: BriefingAuditor

  excludes: string[]
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/models/briefing.model.ts